import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { GenericFilterModel } from 'src/app/security/QueryStringParam';
import { AnnouncementModel, Contacts, DataItemModel } from '../../../shared/model/interfaces';
import {extractContacts, getErrorMessageText} from '../../helper';

@Component({
    selector: 'app-rep-home',
    templateUrl: './rep-home.component.html',
    styleUrls: ['./rep-home.component.css'],
    standalone: false
})
export class RepHomeComponent implements OnInit {

  public forms: DataItemModel[] = [];
  public statements: DataItemModel[] = [];
  public taxes: DataItemModel[] = [];
  public communications: DataItemModel[] = [];
  public confirms: DataItemModel[] = [];

  public rep: any;
  public Announcements: AnnouncementModel[] = [];
  public OwnerShipType = '-';
  public CustodianAccNum = '-';
  public contacts: Contacts;
  public differentLoggedIn: boolean;
  display = false;
  alertmessage: string;
  InboxCount = 0;


  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private ngxService: NgxUiLoaderService,
    private authService: AuthServiceCustom) {
  }

  ngOnInit() {
    this.differentLoggedIn = this.authService.DifferentLoggedIn;

    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];

    genericFilterModel.PageNo = 0;
    genericFilterModel.PageSize = 3;
    genericFilterModel.SortField = '';
    genericFilterModel.SortOrder = '';
    genericFilterModel.SkipRecords = 0;
    genericFilterModel.Filters.push({Key: 'forWhat', Value: 'announcement'});

    const genericFilterModelStatement = new GenericFilterModel();
    genericFilterModelStatement.Filters = [];
    genericFilterModelStatement.Filters.push({Key: 'userType', Value: this.authService.UserType});
    genericFilterModelStatement.PageNo = 0;
    genericFilterModelStatement.PageSize = 0;
    genericFilterModelStatement.SortField = '';
    genericFilterModelStatement.SortOrder = 'asc';
    genericFilterModelStatement.SkipRecords = 0;

    forkJoin(
      this.abstractDataProvider.postData(genericFilterModel, 'api/Form/GetForm'),
      this.abstractDataProvider.postData(genericFilterModelStatement, 'api/Statement/GetStatement'),
      this.abstractDataProvider.getData('api/Rep/GetRepInfo'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetNewMessageCount'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetInbox'),
    )
      .subscribe(([forms, statment, investment, inbox, announcement]) => {
          this.ngxService.stop();

          this.rep = investment;

          this.OwnerShipType = investment.OwnerShipType;
          this.CustodianAccNum = investment.CustodianAccNum;

          this.contacts = extractContacts(investment);

          this.forms = forms.Data.slice(0, 4);
          this.statements = statment.Statements.slice(0, 2);
          this.taxes = statment.Tax.slice(0, 2);
          this.communications = statment.Communications.slice(0, 2);
          this.confirms = statment.Confirms.slice(0, 2);
          this.InboxCount = inbox.InboxCount;
          this.Announcements = announcement.Data;
        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertmessage =  getErrorMessageText(error);

        });
  }


  onConfirm() {
    this.display = false;
  }


  navigateToUnReadMsg() {
    this.authService.navigateToUrl('inbox', {mode: 'unread'});
  }

}
